import React, { useState, useEffect } from "react";
import * as api from "../../lib/api";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { ClipboardCheck } from "lucide-react";
import { CHECK_CONDITIONS, Field, fmtNum } from "./constants";

export function CheckDialog({ printer, open, onClose, onDone }) {
    const [form, setForm] = useState({ date: "", page_counter: "", condition: "ok", notes: "" });
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (open) setForm({ date: new Date().toISOString().slice(0, 10), page_counter: "", condition: "ok", notes: "" });
    }, [open]);

    const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

    const submit = async () => {
        setSaving(true);
        try {
            await api.addPrinterCheck(printer.id, { ...form, page_counter: form.page_counter === "" ? null : Number(form.page_counter) });
            toast.success("Contrôle enregistré");
            onDone?.();
            onClose();
        } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
        finally { setSaving(false); }
    };

    return (
        <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
            <DialogContent className="max-w-md">
                <DialogHeader><DialogTitle className="flex items-center gap-2"><ClipboardCheck className="w-4 h-4 text-teal-600" />Nouveau contrôle — {printer?.name}</DialogTitle></DialogHeader>
                <div className="grid grid-cols-2 gap-3 py-1">
                    <Field label="Date du contrôle"><Input type="date" value={form.date} onChange={set("date")} data-testid="ck-date" /></Field>
                    <Field label={`Compteur de pages${printer?.page_counter ? ` (dernier : ${fmtNum(printer.page_counter)})` : ""}`}>
                        <Input type="number" min="0" value={form.page_counter} onChange={set("page_counter")} placeholder="ex : 45230" data-testid="ck-counter" />
                    </Field>
                    <Field label="État constaté" className="col-span-2">
                        <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-1" data-testid="ck-condition">
                            {Object.entries(CHECK_CONDITIONS).map(([k, v]) => (
                                <button key={k} onClick={() => setForm({ ...form, condition: k })} data-testid={`ck-condition-${k}`}
                                    className={`flex-1 px-2 py-1.5 text-xs font-medium rounded-md transition-colors ${form.condition === k ? `bg-white shadow-sm ${v.color.split(" ")[1]}` : "text-gray-500 hover:text-gray-700"}`}>
                                    {v.label}
                                </button>
                            ))}
                        </div>
                    </Field>
                    <Field label="Remarques" className="col-span-2">
                        <textarea value={form.notes} onChange={set("notes")} rows={3} className="w-full px-2 py-1.5 text-sm border rounded-md" placeholder="Bourrage fréquent, toner faible, nettoyage effectué..." data-testid="ck-notes" />
                    </Field>
                </div>
                <DialogFooter>
                    <Button variant="outline" onClick={onClose}>Annuler</Button>
                    <Button onClick={submit} disabled={saving} data-testid="ck-submit">{saving ? "..." : "Enregistrer"}</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
